import { useMutation, useQuery } from '@tanstack/react-query';
import { addCustomerComment, getCustomerComments } from '../customerCommentService';
import type { AddCustomerCommentContext as CommentContext } from '../schemas/customerServiceSchemas/addCustomerCommentContext';
import type { GetCustomerCommentsParams } from '../schemas/customerServiceSchemas/getCustomerCommentsParams';

/**
 * Hook for adding comments to customers
 */
export const useAddCustomerComment = <TError = Error, TContext = unknown>(
  options?: any
) => {
  return useMutation<
    Awaited<ReturnType<typeof addCustomerComment>>,
    TError,
    { customerId: string; comment: string; context?: CommentContext; createdBy?: string },
    TContext
  >({
    mutationFn: ({ customerId, comment, context, createdBy }) => addCustomerComment(customerId, comment, context, createdBy),
    ...options,
  });
};

/**
 * Hook for retrieving comments for a customer
 */
export const useGetCustomerComments = <TError = Error>(
  customerId: string,
  params?: GetCustomerCommentsParams,
  options?: any
) => {
  return useQuery<Awaited<ReturnType<typeof getCustomerComments>>, TError>({
    queryKey: ['customer-comments', customerId, params],
    queryFn: () => getCustomerComments(customerId, params),
    ...options,
  });
};